import { Box, Pagination } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { pendingFilterValues } from "./PendingAppointmentsFilter";

export default function Paging({ pages = 0 }) {
  const [searchParams, setSearchParams] = useSearchParams();

  //initPage should be 1 for MUI Pagination
  const initPage = 1;
  const [page, setPage] = React.useState(initPage);

  const handlePageChange = (event, value) => {
    // Backend is 0 based and frontend is 1 based. That's why we need to always remove 1 value from the page in order for BE and FE to be in sync
    searchParams.set("page", value - 1);
    setSearchParams(searchParams);
    setPage(value);
  };

  React.useEffect(() => {
    handlePageChange(null, initPage);
  }, [
    searchParams.get(pendingFilterValues.from),
    searchParams.get(pendingFilterValues.to),
    searchParams.get(pendingFilterValues.pet),
    searchParams.get(pendingFilterValues.service),
    searchParams.get(pendingFilterValues.species),
    searchParams.get(pendingFilterValues.user),
  ]);

  if (pages > 0) {
    return (
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          justifyContent: "center",
          mt: 4,
          mb: 2,
        }}
      >
        <Pagination
          count={pages}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    );
  }

  return null;
}
